export interface ComicArticle {
  id: string;
  slug: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  content: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  publishDate: string;
  updateDate: string;
  featured: boolean;
  hot: boolean;
}

export const comicArticles: ComicArticle[] = [
  {
    id: '1',
    slug: 'solo-leveling-after-story',
    title: '我独自升级：后传',
    author: 'Chugong / DUBU',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20solo%20leveling%20after%20story%2C%20dark%20fantasy%20warrior%20with%20shadow%20army%2C%20dramatic%20lighting%2C%20epic%20action%20scene%2C%20manga%20style%20illustration%20with%20Korean%20aesthetic%2C%20clean%20composition%2C%20neutral%20warm%20gray%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    description: '故事承接《我独自升级》大结局，讲述成振宇在成为暗影君主之后的全新冒险。新的敌人出现，更强大的挑战等待着他...',
    content: '<p>在《我独自升级》的结局中，成振宇成功击败了所有敌人，成为了史上最强的猎人。然而，和平并没有持续太久。</p><p>来自异次元的全新威胁悄然降临，这一次，成振宇不仅要面对更加强大的敌人，还要保护他所珍视的一切。</p><p>在全新的冒险中，成振宇将遇到新的盟友，也会发现关于暗影君主力量的更多秘密。他能否再次守护这个世界？</p>',
    tags: ['热血', '战斗', '奇幻', '升级流'],
    rating: 4.9,
    views: 1258000,
    chapters: 42,
    status: '连载中',
    publishDate: '2025-03-15',
    updateDate: '2026-08-01',
    featured: true,
    hot: true,
  },
  {
    id: '2',
    slug: 'secret-lady-empress',
    title: '秘密女帝',
    author: 'Studio Inus',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20beautiful%20empress%20in%20historical%20royal%20palace%2C%20soft%20romantic%20atmosphere%2C%20elegant%20hanbok%20style%20dress%2C%20warm%20golden%20tone%2C%20watercolor%20illustration%20style%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    description: '在皇宫中隐藏身份的女帝，与意外闯入宫廷的年轻画师之间展开的秘密恋情。身份与爱情之间，她将如何抉择？',
    content: '<p>李贤雅是朝鲜王朝的女帝，但她必须隐藏自己的真实身份，因为在那个时代，女性统治者不被认可。</p><p>一天，一位才华横溢的年轻画师朴道河被召入宫中为皇室画像。他的真诚和才华逐渐打动了贤雅的心。</p><p>然而，朝中大臣的阴谋、邻国的威胁，以及身份的束缚，都在考验着这段秘密的恋情...</p>',
    tags: ['恋爱', '古风', '宫廷', '女强'],
    rating: 4.8,
    views: 985000,
    chapters: 56,
    status: '连载中',
    publishDate: '2025-01-20',
    updateDate: '2026-08-02',
    featured: true,
    hot: true,
  },
  {
    id: '3',
    slug: 'magic-academy-prodigy',
    title: '魔法学院的天才',
    author: 'Kim Eunsook',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20magic%20academy%20student%20casting%20powerful%20spell%2C%20bright%20magical%20effects%20and%20runes%2C%20anime%20style%20illustration%2C%20vibrant%20colors%20with%20mystical%20atmosphere%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    description: '被认为没有魔法天赋的少年，在魔法学院入学测试中意外展现出惊人才能。他的真实身份究竟是什么？',
    content: '<p>在一个人人都会魔法的世界里，尹辰宇是罕见的"无魔力者"。然而当他被迫进入帝国魔法学院后，一切都变了。</p><p>在一次意外中，辰宇发现自己体内封印着上古魔龙的灵魂，这股力量让他的魔力远超常人。</p><p>随着学院生活的展开，辰宇不仅要学会控制这股力量，还要揭开自己身世的秘密...</p>',
    tags: ['奇幻', '魔法', '校园', '成长'],
    rating: 4.7,
    views: 756000,
    chapters: 68,
    status: '连载中',
    publishDate: '2024-11-05',
    updateDate: '2026-08-03',
    featured: true,
    hot: true,
  },
  {
    id: '4',
    slug: 'my-boss-is-a-cat',
    title: '我的老板是只猫',
    author: 'Lee Minji',
    category: '搞笑',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20cute%20office%20worker%20girl%20with%20a%20cat%20boss%2C%20funny%20office%20daily%20life%2C%20chibi%20art%20style%2C%20light%20heartwarming%20tone%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    description: '新入职的职场新人发现自己的上司居然是一只会说话的猫！在搞笑又温馨的日常中，她逐渐发现了这只猫的秘密...',
    content: '<p>金多喜终于找到了理想的工作，但她万万没想到，自己的直属上司——公司的创意总监——居然是一只猫！</p><p>这只名叫"社长"的猫不仅能说人话，还比任何人都懂创意和商业。更神奇的是，整个公司似乎只有多喜一个人觉得这很奇怪。</p><p>在啼笑皆非的日常中，多喜逐渐揭开了社长身上的秘密，也找到了自己真正的价值...</p>',
    tags: ['搞笑', '日常', '治愈', '职场'],
    rating: 4.6,
    views: 642000,
    chapters: 35,
    status: '连载中',
    publishDate: '2025-06-10',
    updateDate: '2026-07-28',
    featured: false,
    hot: true,
  },
  {
    id: '5',
    slug: 'crimson-moon-detective',
    title: '红月侦探社',
    author: 'Park Seojun',
    category: '悬疑',
    categorySlug: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%2C%20mysterious%20detective%20in%20rainy%20night%20city%2C%20noir%20atmosphere%2C%20red%20moon%20in%20sky%2C%20dark%20moody%20tone%2C%20realistic%20manhwa%20style%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    description: '每当红月升起，城市中就会出现离奇案件。独立侦探韩智浩接手了一个看似普通却暗藏玄机的委托...',
    content: '<p>首尔市接连发生离奇案件，而所有案件都有一个共同点——案发当晚都出现了红色的月亮。</p><p>独立侦探韩智浩接到一个匿名委托，调查一起看似普通的失踪案。但随着调查深入，他发现这起案件与十年前的一桩悬案有着千丝万缕的联系。</p><p>在追查真相的过程中，智浩发现自己也已经成为了某个神秘组织的目标...</p>',
    tags: ['悬疑', '侦探', '都市', '推理'],
    rating: 4.8,
    views: 523000,
    chapters: 28,
    status: '连载中',
    publishDate: '2025-09-01',
    updateDate: '2026-07-30',
    featured: false,
    hot: true,
  },
  {
    id: '6',
    slug: 'spring-of-nineteen',
    title: '十九岁的春天',
    author: 'Choi Yuna',
    category: '校园',
    categorySlug: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%2C%20high%20school%20students%20under%20cherry%20blossoms%2C%20spring%20campus%20scene%2C%20youth%20romance%20atmosphere%2C%20soft%20pastel%20tones%2C%20watercolor%20illustration%20style%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    description: '高三最后一个春天，五个性格迥异的好朋友在校园中经历的青春故事。友情、梦想、初恋，所有美好的事物都在这里...',
    content: '<p>高三的最后一个春天，对于尹智秀和她的四个好朋友来说，这可能是人生中最特别的时光。</p><p>有人为了高考拼命努力，有人偷偷暗恋着隔壁班同学，有人为了音乐梦想不顾一切。五个人的故事交织在一起，构成了最美好的青春回忆。</p><p>当樱花飘落的时候，他们每个人都将面对人生的十字路口...</p>',
    tags: ['校园', '青春', '友情', '成长'],
    rating: 4.7,
    views: 489000,
    chapters: 45,
    status: '已完结',
    publishDate: '2024-04-01',
    updateDate: '2025-12-20',
    featured: false,
    hot: false,
  },
  {
    id: '7',
    slug: 'heavenly-demon-chronicles',
    title: '天魔纪事',
    author: 'Jung Hyunwoo',
    category: '古风',
    categorySlug: 'historical',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%2C%20ancient%20Korean%20warrior%20with%20heavenly%20demon%20powers%2C%20martial%20arts%20scene%2C%20traditional%20Korean%20costume%2C%20epic%20wuxia%20style%2C%20dramatic%20brush%20ink%20painting%20style%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    description: '被诬陷为魔教妖人的少年，在绝境中觉醒了天魔之力。他以一己之力对抗整个武林，书写属于自己的传奇...',
    content: '<p>在武林中，"天魔教"是人人喊打的邪教组织。少年秦风从小被天魔教收养，却不知自己的真实身世。</p><p>当正派武林联合讨伐天魔教时，秦风被发现身上流淌着天魔血脉。在生死关头，他觉醒了传说中的天魔之力。</p><p>从此，他踏上了一条复仇与寻找真相的道路，誓要为自己和天魔教正名...</p>',
    tags: ['古风', '武侠', '奇幻', '复仇'],
    rating: 4.6,
    views: 412000,
    chapters: 60,
    status: '连载中',
    publishDate: '2024-08-15',
    updateDate: '2026-08-01',
    featured: false,
    hot: false,
  },
  {
    id: '8',
    slug: 'everyday-with-you',
    title: '和你在一起的每一天',
    author: 'Han Soyoung',
    category: '日常',
    categorySlug: 'daily',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20young%20couple%20in%20cozy%20apartment%20daily%20life%2C%20warm%20home%20atmosphere%2C%20cooking%20and%20reading%20together%2C%20soft%20natural%20lighting%2C%20gentle%20illustration%20style%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    description: '一对普通情侣的日常琐事，从一起做饭到一起旅行，记录生活中每一个温暖的瞬间。治愈系日常漫画...',
    content: '<p>没有惊天动地的冒险，没有错综复杂的阴谋，这就是两个普通人——智恩和敏浩——的温馨日常。</p><p>从第一次一起做饭时的手忙脚乱，到周末窝在沙发上看电影的慵懒午后，再到旅途中遇到的各种小插曲。</p><p>生活中的每一件小事，因为有了彼此的陪伴，都变得特别而美好...</p>',
    tags: ['日常', '治愈', '恋爱', '温馨'],
    rating: 4.9,
    views: 378000,
    chapters: 72,
    status: '连载中',
    publishDate: '2024-02-14',
    updateDate: '2026-08-02',
    featured: false,
    hot: false,
  },
  {
    id: '9',
    slug: 'the-last-dragon-knight',
    title: '最后的龙骑士',
    author: 'Seo Kangwoo',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20action%20manhwa%20cover%2C%20dragon%20knight%20riding%20ancient%20dragon%20in%20sky%2C%20epic%20battle%20scene%2C%20medieval%20fantasy%20setting%2C%20dynamic%20composition%2C%20detailed%20armor%20design%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    description: '当世界上最后一条龙选择了平凡少年李镇赫作为骑士，一场改变命运的冒险就此展开。龙与骑士的传奇...',
    content: '<p>在这个魔法逐渐消失的时代，龙已经成为了传说中的生物。直到那一天，少年李镇赫在深山中遇到了世界上最后一条龙——艾尔德拉。</p><p>这条古老的龙选择了他作为最后的龙骑士，赋予了他守护世界的力量。但黑暗势力也在觊觎着龙的力量...</p><p>镇赫必须快速成长，学会与龙并肩作战，因为他们面对的是一个足以毁灭整个王国的威胁。</p>',
    tags: ['奇幻', '冒险', '龙', '战斗'],
    rating: 4.5,
    views: 345000,
    chapters: 38,
    status: '连载中',
    publishDate: '2025-07-20',
    updateDate: '2026-07-29',
    featured: false,
    hot: false,
  },
  {
    id: '10',
    slug: 'love-contract-impossible',
    title: '不可能的恋爱契约',
    author: 'Yoon Jaehyun',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20manhwa%20cover%2C%20handsome%20CEO%20and%20ordinary%20girl%20contract%20relationship%2C%20modern%20Seoul%20cityscape%20background%2C%20bittersweet%20romance%2C%20elegant%20fashion%2C%20soft%20mood%20lighting%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    description: '为了偿还父亲的债务，姜彩妍与冷酷总裁签订了一份恋爱契约。但谁也没想到，这份契约最终改变了两个人的一生...',
    content: '<p>姜彩妍的父亲欠下了巨额债务后不知所踪，年仅二十四岁的她一夜之间背负了五亿韩元的债务。</p><p>走投无路之际，年轻有为的企业总裁车敏浩向她提出了一个不可思议的提议——假扮他的女友一年，帮他对付家族的逼婚。</p><p>彩妍接受了这份"恋爱契约"，但她没想到的是，这个冷酷的男人背后有着不为人知的温柔...</p>',
    tags: ['恋爱', '契约', '都市', '总裁'],
    rating: 4.7,
    views: 567000,
    chapters: 50,
    status: '已完结',
    publishDate: '2024-06-01',
    updateDate: '2025-08-15',
    featured: false,
    hot: true,
  },
  {
    id: '11',
    slug: 'reincarnation-of-sword-saint',
    title: '剑圣重生',
    author: 'Baek Taehyun',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20manhwa%20cover%2C%20sword%20master%20reincarnated%20with%20ancient%20sword%2C%20martial%20arts%20cultivation%20theme%2C%20dynamic%20fighting%20pose%2C%20golden%20energy%20effects%2C%20epic%20illustration%20style%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    description: '一代剑圣在渡劫失败后意外重生回到少年时代。带着前世的记忆和剑术，他要改写自己的命运...',
    content: '<p>剑圣白逸尘在渡天劫时遭到暗算，含恨陨落。然而天道给了他一次重来的机会——他重生回到了十六岁那年。</p><p>带着三百年的剑术修为和记忆，白逸尘决定这一次不再重蹈覆辙。他要比前世更早修炼，更快变强，找出那个暗算他的幕后黑手。</p><p>但重来的人生并非一帆风顺，新的敌人和挑战都在等待着他...</p>',
    tags: ['重生', '武侠', '修真', '爽文'],
    rating: 4.8,
    views: 890000,
    chapters: 95,
    status: '连载中',
    publishDate: '2024-01-10',
    updateDate: '2026-08-03',
    featured: true,
    hot: true,
  },
  {
    id: '12',
    slug: 'ghost-stories-club',
    title: '怪谈社',
    author: 'Moon Jiwon',
    category: '悬疑',
    categorySlug: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20mystery%20manhwa%20cover%2C%20school%20ghost%20stories%20club%20in%20dark%20classroom%2C%20eerie%20supernatural%20atmosphere%2C%20flashlight%20under%20faces%2C%20spooky%20but%20artistic%20style%2C%20clean%20neutral%20background%2C%20professional%20comic%20art&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    description: '学校里有一个神秘的"怪谈社"，社员们专门调查校园中的灵异事件。每个故事都让人背后发凉...',
    content: '<p>翰林高中的角落里有一个不起眼的社团——怪谈社。这里聚集了一群对超自然现象充满好奇的学生。</p><p>每一个章节都是一个独立的怪谈故事：会移动的人体模型、永远打不开的第四间厕所、深夜琴房传来的钢琴声...</p><p>但随着调查的深入，社员们发现，这些看似独立的怪谈之间，似乎存在着某种联系...</p>',
    tags: ['悬疑', '恐怖', '校园', '单元剧'],
    rating: 4.5,
    views: 298000,
    chapters: 22,
    status: '连载中',
    publishDate: '2026-01-05',
    updateDate: '2026-07-25',
    featured: false,
    hot: false,
  },
];

export function getFeaturedComics(): ComicArticle[] {
  return comicArticles.filter(c => c.featured);
}

export function getHotComics(): ComicArticle[] {
  return comicArticles.filter(c => c.hot);
}

export function getComicsByCategory(slug: string): ComicArticle[] {
  if (slug === 'all') return comicArticles;
  return comicArticles.filter(c => c.categorySlug === slug);
}

export function getComicBySlug(slug: string): ComicArticle | undefined {
  return comicArticles.find(c => c.slug === slug);
}

export function getLatestUpdates(limit: number = 8): ComicArticle[] {
  return [...comicArticles].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
}